import { Component, OnInit } from '@angular/core';
import { QuestionService } from "../Services/question.service";
import * as constant from '../constant';
import { MyModalService } from '../Services/modal-service.service';

@Component({
  selector: 'app-enquete-setting',
  templateUrl: './enquete-setting.component.html',
  styleUrls: ['./enquete-setting.component.css']
})
export class EnqueteSettingComponent implements OnInit {
  readonly TEXT_BOX = constant.TEXT_BOX;
  readonly NUMBER_BOX = constant.NUMBER_BOX;
  readonly MAIL_BOX = constant.MAIL_BOX;
  readonly DATE_BOX = constant.DATE_BOX;
  readonly TELL_BOX = constant.TELL_BOX;
  readonly RADIO = constant.RADIO_BUTTON;
  readonly CHECK_BOX = constant.CHECK_BOX;
  readonly SELECT = constant.SELECT_BOX;
  readonly ADDRESS = constant.ADDRESS_FORM;


  questionList: any;
  categoryList: any[];
  viewList: any[];

  category: any;

  select_item;
  select_option;

  add_category: string;

  formValue: string;
  formType: number;
  formOther: number;

  formOption: string;

  constructor(
    private qs: QuestionService,
    private modal: MyModalService,
  ) { }

  ngOnInit() {
    this.qs.getQuestionList(0).subscribe(list => {
      this.questionList = list;
      this.init();
    });
  }

  /**
   * 初期化処理
   * SQLから取得してきたテーブルから
   * 項目とその中身の仕分け
   */
  init() {
    //項目種類抽出
    let temp = this.questionList.filter(function (item, i, self) {
      return (self.findIndex(function (item2) {
        return (item.question_no === item2.question_no)
      }) === i);
    });

    let tempList = [];
    temp.forEach(item => {
      let i = {
        question_no: item.question_no,
        question_category: item.question_category
      }
      tempList.push(i);
    });

    //先頭の項目を選択
    this.categoryList = tempList;
    //this.category = tempList[Object.keys(tempList)[0]].question_no;
    this.category;

    this.viewer();
  }

  /**
   * 保存
   */
  async update() {
    const res = await this.modal.confirm('保存', '変更を保存しますがよろしいでしょうか？');
    if (!res) {
      return;
    }
    this.qs.updateQuestionList(this.questionList).subscribe(res => {
      this.modal.message('保存完了', '保存完了しました');
      this.ngOnInit();
    });
  }

  /**
   * 表示項目の切り替え
   */
  change() {
    this.selectClear();
    this.viewer();
  }

  /**
   * リストの更新
   */
  viewer() {
    this.questionList.sort(function (a, b) {
      if (a.question_no < b.question_no) return -1;
      if (a.question_no > b.question_no) return 1;
      if (a.question_sort < b.question_sort) return -1;
      if (a.question_sort > b.question_sort) return 1;
      return 0;
    })

    this.viewList = this.questionList.filter((item) => {
      return item.question_no === this.category;
    });
  }


  //クリックした行をselect
  select(item) {
    this.selectClear();
    this.select_item = item;
    item.select = true;
  }

  //selectを一旦全部消去
  selectClear() {
    this.select_item = null;
    this.select_option = null;
    this.viewList.forEach(item => {
      item.select = false;
    });
  }

  //クリックした行をselect
  select_opt(index) {
    this.select_option = index;
  }

  //アンケート項目の追加
  add() {
    if (this.formValue != undefined && this.formType != undefined && this.category) {
      let cate = this.categoryList.find((item) => { return (item.question_no === this.category) });
      let question_sort = 1;

      if (this.viewList.length > 0) {
        question_sort = this.viewList[this.viewList.length - 1].question_sort + 1;
      }

      var temp = {
        question_code: null,
        question_no: this.category,
        question_category: cate.question_category,
        question_info: this.formValue,
        question_answer_type: this.formType,
        question_answer_items: [],
        question_sort: question_sort,
        question_disabled_flag: 0,
        question_other_flag: 0,
      }

      this.questionList.push(temp);
      this.formValue = undefined;
      this.viewer();
    }
  }

  /**
   * 項目の追加
   */
  addCategory() {
    if (this.add_category != undefined) {
      var no = 1;
      if(this.categoryList) {
        no = this.categoryList.length + 1;
      }
      var temp = {
        question_no: String(no),
        question_category: this.add_category
      }

      this.categoryList.push(temp);
      this.add_category = undefined;
    }
  }

  //削除.
  async del(item) {
    const res = await this.modal.confirm('削除', '『' + item.question_info + '』を本当に削除してもよろしいですか？');
    if (!res) {
      return;
    }

    let cate_no = item.question_no;

    if (item.question_code != null) {
      item.question_no = null;
    } else {
      let index = this.questionList.findIndex(i => i == item);
      this.questionList.splice(index, 1);
    }
    let sort = 1;
    this.questionList.forEach(item => {
      if (item.question_no == cate_no) {
        item.question_sort = sort;
        sort++;
      }
    });

    this.selectClear();
    this.viewer();
  }

  //項目の並び順変更
  prev() {
    if (!!this.viewList && this.select_item) {
      //選択中のindexと 1つ前のindex
      let index = this.questionList.findIndex(i => i.question_no == this.select_item.question_no && i.question_sort === this.select_item.question_sort);
      let index2 = this.questionList.findIndex(i => i.question_no == this.select_item.question_no && i.question_sort === this.select_item.question_sort - 1);

      if (index != 0) {
        if (index2 > -1) {
          let temp = this.questionList[index].question_sort;
          this.questionList[index].question_sort = this.questionList[index2].question_sort;
          this.questionList[index2].question_sort = temp;
          this.viewer();
        } else {
          this.questionList[index].question_sort--;
          this.prev();
        }
      }
    }
  }

  next() {
    if (!!this.viewList && this.select_item) {
      //選択中のindexと 1つ前のindex
      let index = this.questionList.findIndex(i => i.question_no == this.select_item.question_no && i.question_sort === this.select_item.question_sort);
      let index2 = this.questionList.findIndex(i => i.question_no == this.select_item.question_no && i.question_sort === this.select_item.question_sort + 1);

      if (index2 > -1) {
        let temp = this.questionList[index].question_sort;
        this.questionList[index].question_sort = this.questionList[index2].question_sort;
        this.questionList[index2].question_sort = temp;
        this.viewer();
      }
    }
  }

  //オプションの追加
  add_opt() {
    if (this.formOption != undefined) {
      if (this.select_item.question_answer_type == this.TEXT_BOX) {
        if (this.select_item.question_answer_items.length == 0) {
          this.select_item.question_answer_items.push(this.formOption);
          this.formOption = undefined;
        }
      } else {
        this.select_item.question_answer_items.push(this.formOption);
        this.formOption = undefined;
      }
    }
  }

  //オプションの削除
  async del_opt(index) {
    let item = this.select_item.question_answer_items[index];
    const res = await this.modal.confirm('削除', '『' + item + '』を本当に削除してもよろしいですか？');
    if (!res) {
      return;
    }

    this.select_item.question_answer_items.splice(index, 1);
  }

  //オプションの並び順変更
  prev_opt() {
    if (!!this.viewList && this.select_option != null) {
      if (this.select_option > 0) {
        let temp = this.select_item.question_answer_items[this.select_option];
        this.select_item.question_answer_items[this.select_option] = this.select_item.question_answer_items[this.select_option - 1];
        this.select_item.question_answer_items[this.select_option - 1] = temp;
        this.select_option--;
      }
    }
  }

  next_opt() {
    if (!!this.viewList && this.select_option != null) {
      if (this.select_option < this.select_item.question_answer_items.length - 1) {
        let temp = this.select_item.question_answer_items[this.select_option];
        this.select_item.question_answer_items[this.select_option] = this.select_item.question_answer_items[this.select_option + 1];
        this.select_item.question_answer_items[this.select_option + 1] = temp;
        this.select_option++;
      }
    }
  }
}
